import Reflux from 'reflux';

import * as MoviesApi from './MoviesApi';

// TODO refactor with MoviesActions

function bindActionToApi(action, api, apiResultMapper = result => result) {
    action.listen(function(...args) {
        api(...args).then(r => {
            this.completed(apiResultMapper(r))
        }).catch(e => {
            console.error(e);
            this.failed(e);
        });
    })
}

export const getMovie = Reflux.createAction({sync: false, asyncResult: true});
export const getNowBookingMovies = Reflux.createAction({sync: false, asyncResult: true});
export const getNewMoviesThisWeek = Reflux.createAction({sync: false, asyncResult: true});

bindActionToApi(getMovie, MoviesApi.get);
bindActionToApi(getNowBookingMovies, MoviesApi.nowbooking);
bindActionToApi(getNewMoviesThisWeek, MoviesApi.newthisweek);



// WEBPACK FOOTER //
// ./js/movies/core/MoviesActions.js